import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Button, ButtonTheme } from '@apply/components';
import { toApiError } from '../api/errors';

interface StepErrorBannerProps {
    error: unknown;
    message?: string;
    onRetry?: () => void;
    onDismiss?: () => void;
}

export const StepErrorBanner: React.FC<StepErrorBannerProps> = ({
    error,
    message,
    onRetry,
    onDismiss,
}) => {
    const apiError = toApiError(error);

    // The first message is the headline; any others are listed under it
    const detail = apiError.messages.slice(1);

    return (
        <div
            className='bp-errorBanner'
            role='alert'
        >
            <FontAwesomeIcon
                className='bp-errorBanner__icon'
                icon={faCircleExclamation}
            />
            <div className='bp-errorBanner__text'>
                <div>{message ?? apiError.messages[0]}</div>
                {detail.length > 0 && (
                    <ul className='bp-errorBanner__detail'>
                        {detail.map((line) => (
                            <li key={line}>{line}</li>
                        ))}
                    </ul>
                )}
            </div>
            <div className='bp-errorBanner__actions'>
                {onRetry && apiError.isRetryable && (
                    <Button
                        id='bpErrorRetry'
                        dataTestid='bpErrorRetryButton'
                        theme={ButtonTheme.LinkBlue}
                        handleClick={onRetry}
                    >
                        Try Again
                    </Button>
                )}
                {onDismiss && (
                    <Button
                        id='bpErrorDismiss'
                        dataTestid='bpErrorDismissButton'
                        theme={ButtonTheme.LinkBlue}
                        handleClick={onDismiss}
                    >
                        Dismiss
                    </Button>
                )}
            </div>
        </div>
    );
};
